import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const CarHistoryIcon = ({
  width = 56,
  height = 56,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="28"
        cy="28"
        r="26"
        fill="#0D2E68"
        stroke="url(#paint0_linear)"
        strokeWidth="4"
      />
      <path
        d="M37.625 14H18.375C17.613 14 
        17 14.6061 17 15.3594V41.6406C17 42.3939 
        17.613 43 18.375 43H37.625C38.387 43 39 42.3939 
        39 41.6406V15.3594C39 14.6061 38.387 14 37.625 
        14ZM20.6667 20.3438C20.6667 19.8453 21.0792 19.4375 
        21.5833 19.4375H23.4167C23.9208 19.4375 24.3333 19.8453 
        24.3333 20.3438V22.1562C24.3333 22.6547 23.9208 23.0625 
        23.4167 23.0625H21.5833C21.0792 23.0625 20.6667 22.6547 
        20.6667 22.1562V20.3438ZM20.7583 27.673L21.4859 26.9594C21.6063 
        26.8404 21.801 26.8404 21.9214 26.9594L23.1016 28.1375L25.8286 
        25.4641C25.949 25.3451 26.1438 25.3451 26.2641 25.4641L26.9859 
        26.1834C27.1063 26.3023 27.1063 26.4949 26.9859 26.6139L23.3078 
        30.2162C23.1875 30.3352 22.9927 30.3352 22.8724 30.2162L20.7583 
        28.1035C20.638 27.9846 20.638 27.792 20.7583 27.673ZM24.3333 
        36.6562C24.3333 37.1547 23.9208 37.5625 23.4167 37.5625H21.5833C21.0792 
        37.5625 20.6667 37.1547 20.6667 36.6562V34.8438C20.6667 34.3453 21.0792 
        33.9375 21.5833 33.9375H23.4167C23.9208 33.9375 24.3333 34.3453 24.3333 
        34.8438V36.6562ZM35.3333 36.2031C35.3333 36.4523 35.1271 36.6562 34.875 
        36.6562H26.625C26.3729 36.6562 26.1667 36.4523 26.1667 36.2031V35.2969C26.1667 
        35.0477 26.3729 34.8438 26.625 34.8438H34.875C35.1271 34.8438 35.3333 35.0477 
        35.3333 35.2969V36.2031ZM35.3333 28.9531C35.3333 29.2023 35.087 29.4062 
        34.7833 29.4062H26.751C26.751 29.4062 28.424 27.6957 28.4927 
        27.5938H34.7776C35.0812 27.5938 35.3276 27.7977 35.3276 
        28.0469V28.9531H35.3333ZM35.3333 21.7031C35.3333 21.9523 
        35.1271 22.1562 34.875 22.1562H26.625C26.3729 22.1562 
        26.1667 21.9523 26.1667 21.7031V20.7969C26.1667 20.5477 
        26.3729 20.3438 26.625 20.3438H34.875C35.1271 20.3438 
        35.3333 20.5477 35.3333 20.7969V21.7031Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="28"
          y1="4"
          x2="28"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.bright_turquoise} />
          <stop offset="1" stopColor="#CEE8FF" />
        </linearGradient>
      </defs>
    </svg>
  </VectorIcon>
);

export default CarHistoryIcon;
